import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { HiCog, HiUpload, HiCalendar,HiX } from "react-icons/hi";
import axios from "../../utils/axios";
import Select from "react-select";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { getUser } from "../../utils/Common";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { id } from "date-fns/locale"; // Indonesian locale
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import {NumericFormat} from 'react-number-format';

const RateSetting = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const { url, hotel_id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [propData, setPropData] = useState([]);
  const [rateList, setRateList] = useState([]);
  const [sortRoomSale, setSortRoomSale] = useState("");
  const [statusRateFilter, setStatusRateFilter] = useState("");
  
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedRoomSale, setSelectedRoomSale] = useState(null);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isRateAddbyDateModalOpen, setIsRateAddbyDateModalOpen] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isRateModalOpen, setIsRateModalOpen] = useState(false);
  const [rateDetail, setRateDetail] = useState(null);
  const [month, setMonth] = useState(moment().month() + 1); // Default to current month
  const [year, setYear] = useState(moment().year()); 
  const [roomSale, setRoomSale] = useState({}); 
  const today = new Date();

  // State to manage the form data add rate based on date
  const [price, setPrice] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [quota, setQuota] = useState(0);
  const [status, setStatus] = useState(99);
  const [selectedRange, setSelectedRange] = useState({ from: null, to: null });

  const handleStatusToggle = () => {
    // Toggle between 1 (active) and 99 (non-active)
    setStatus(status === 1 ? 99 : 1);
  };

  const handleSortRoomSale = (e) => {
    setSortRoomSale(e.target.value); // Set the selected room sale ID
  };

  // Handle status rate filter change
  const handleStatusRateFilter = (e) => {
    setStatusRateFilter(e.target.value);
  };

  const handlePriceChange = (values) => {
    setPrice(values.value); // The raw number without formatting
  };

  const handleAddRatebasedOnDate = async () => {
    var userHID = localStorage.getItem("hid");
    const formData = {
      price,
      discount,
      quota,
      status,
      hotelID:userHID,
      roomSaleID:roomSale.ID_ROOM_SALE,
      startDate: moment(selectedRange.from).format('YYYY-MM-DD'),
      endDate: moment(selectedRange.to).format('YYYY-MM-DD'),
    };
    console.log('Form Data:', formData);
    // Add your save logic here, e.g., make an API request to save the data

    try {
      setLoading(true);
      const response = await axios.post("/api/insert/rate/bydate", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      });
      // console.log(response.data)
      if (response.status === 200) {
        window.location.reload()
      } else {
        throw new Error("Failed to upload the file.");
      }
    } catch (err) {
      console.error("Upload Error:", err);
      toast.error("Error add rate date. Please try again.");
    } finally {
      setLoading(false);
    }
  }
  
  const handleUploadModalToggle = (idRoomSale) => {
    console.log(idRoomSale)
    setSelectedRoomSale(idRoomSale)
    setIsUploadModalOpen(!isUploadModalOpen);
  };

  const handleFileUpload = async () => {
    if (!selectedFile || !selectedRoomSale) {
      toast.error("Please select a file to upload.");
      return;
    }
    
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("hotel_id", hotel_id);
    formData.append("room_sales_id", selectedRoomSale);
  
    try {
      setLoading(true);
      
      const response = await axios.post("/rate/upload/excel", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          // Calculate the progress percentage
          const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          setUploadProgress(progress);
        },
      });

      console.log(response.data)
  
      if (response.status === 200) {
        toast.success(response.data.message);
        // Optionally refresh the rate list after upload
        getRatePlanList(hotel_id);
        setIsUploadModalOpen(false);
      } else {
        throw new Error("Failed to upload the file.");
      }
    } catch (err) {
      console.error("Upload Error:", err);
      toast.error("Error uploading the file. Please try again.");
    } finally {
      setLoading(false);
      setUploadProgress(0); 
    }
  };
  
  const getRatePlanList = async (hotel_id, sortOrder = 'asc') => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/rate-plan/room/list/${hotel_id}/${month}/${year}`);
      if (response.status === 200) {
        const sortedData = response.data.sort((a, b) => {
          return sortOrder === 'asc'
            ? a.ROOM_NAME.localeCompare(b.ROOM_NAME)
            : b.ROOM_NAME.localeCompare(a.ROOM_NAME);
        });
        setRateList(sortedData);
        console.log(sortedData);
      } else {
        throw new Error("Failed to fetch room data");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };
  
  const getDetailProperty = async (hotel_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/detail/hotel/${hotel_id}`);
      if (response.status === 200) {
        setPropData(response.data);
      } else {
        throw new Error("Query / network reloading");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };

  const getDetailRate = async (date_from,id_room_sale) => {
    setLoading(true);
    // console.log(date_from)
    // console.log(id_room_sale)
    try {
      const response = await axios.get(`/api/detail/rate/${hotel_id}/${id_room_sale}/${date_from}`);
      console.log(response.data)
      if (response.status === 200) {
        setRateDetail(response.data.data); // Set the rate detail data
        setIsRateModalOpen(true); // Open the modal
      } else {
        throw new Error("Failed to fetch rate detail");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  }

  const handlePriceChangeDetail = (values) => {
    setRateDetail((prev) => ({ ...prev, PRICE_ROOM: values.value }));
  };

  const updateRateDetail = async () => {
    if (!rateDetail || !rateDetail.ID_RATE) {
      toast.error("No rate details to update.");
      return;
    }
  
    try {
      setLoading(true);
      const payload = {
        UID:userData.id,
        ID_RATE: rateDetail.ID_RATE,
        HOTEL_ID: hotel_id,
        ROOM_SALES_ID: rateDetail.ROOM_SALES_ID,
        FROM_DATE: rateDetail.FROM_DATE,
        TO_DATE: rateDetail.TO_DATE,
        PRICE_ROOM: rateDetail.PRICE_ROOM,
        ALLOCATION: rateDetail.ALLOCATION,
        STATUS_RATE: rateDetail.STATUS_RATE,
      };
  
      const response = await axios.post(`/api/update/detail/rate`, payload);
      console.log(response.data)
      if (response.status === 200) {
        toast.success(response.message);
        setIsRateModalOpen(false);
        getRatePlanList(hotel_id); // Refresh the rate plan list
      } else {
        throw new Error("Failed to update rate details.");
      }
    } catch (err) {
      console.error("Update Error:", err);
      toast.error("Error updating the rate details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const generateAllDates = (month, year) => {
    const daysInMonth = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();
    const dates = [];
    for (let i = 1; i <= daysInMonth; i++) {
      dates.push(moment(`${year}-${month}-${i}`, "YYYY-MM-DD").format("YYYY-MM-DD"));
    }
    return dates;
  };

  const handleAddRatebyDate = (room) => {
    console.log(room)
    setRoomSale(room)
    setIsRateAddbyDateModalOpen(true)
  }
  
  // Updated JSX
  const allDates = generateAllDates(month, year);

  useEffect(() => {
    var userHID = localStorage.getItem("hid");
    const userSession = getUser(); // Call getUser to fetch user data from localStorage
    if (userSession) {
      setUserData(userSession); // Store user data in the state if it exists
      getDetailProperty(userHID);
      getRatePlanList(userHID)
    } else {
      navigate('/'); // Optionally clear the user data if not found
    }
  }, [month]);

  return (
    <div className="flex h-screen bg-gray-200">
      <Sidebar
        setMiniSidebar={setMiniSidebar}
        isMiniSidebar={isMiniSidebar}
        propertyID={propData.ID_HOTEL || "Loading..."}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar 
          setMiniSidebar={setMiniSidebar} 
          isMiniSidebar={isMiniSidebar} 
        />
        <main className="flex-1 p-5 overflow-y-auto bg-gray-100">
        <div className="mb-4 text-sm text-[#101827]">
            <span>Ashley Hotel Group</span> &gt; <span>Room Rate Calendar</span> &gt;{" "}
            <span>{propData.NAME_HOTEL}</span>
        </div>
          <section className="bg-white rounded shadow-md py-4 px-6 text-[#101827] mb-6 w-full">
             
            <div className="flex space-x-4 mb-4 items-center overflow-x-auto hide-scrollbar">
              <div className="flex flex-col">
                <label htmlFor="month" className="text-xs font-medium text-gray-700 mb-2">
                  Sort by Month
                </label>
                <select
                  id="month"
                  className="border border-gray-300 rounded-lg p-2 text-sm"
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                >
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i} value={i + 1}>
                      {moment().month(i).format("MMMM")}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex flex-col">
                <label htmlFor="year" className="text-xs font-medium text-gray-700 mb-2">
                  Sort by Year
                </label>
                <select
                  id="year"
                  className="border border-gray-300 rounded-lg p-2 text-sm"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                >
                  {Array.from({ length: 10 }, (_, i) => (
                    <option key={i} value={moment().year() + i}>
                      {moment().year() + i}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex flex-col">
                <label htmlFor="roomrate" className="text-xs font-medium text-gray-700 mb-2">
                  Sort by Room Rate
                </label>
                <select
                  id="roomrate"
                  className="border border-gray-300 rounded-lg p-2 text-sm"
                  value={selectedRoomSale}
                  onChange={handleSortRoomSale}
                >
                <option value="">All Room Plan</option>
                {rateList.map((room,index) => (
                  <option key={index} value={room.ID_ROOM_SALE}>
                    {room.ROOM_NAME}
                  </option>
                ))}  
                </select>
              </div>

              <div className="flex flex-col">
                <label htmlFor="statusrate" className="text-xs font-medium text-gray-700 mb-2">
                  Sort by Status 
                </label>
                <select
                  id="roomrate"
                  className="border border-gray-300 rounded-lg p-2 text-sm"
                  value={statusRateFilter}
                  onChange={handleStatusRateFilter}
                >
                <option value="">All Status</option>
                <option value="1">Active</option>
                <option value="0">Non Active</option>
                </select>
              </div>
            </div>

            {rateList.length === 0 ? (
              <div className="text-center text-gray-500 py-4">No rates available</div>
            ) : (

              rateList
              .filter((room) => {
                // Apply filter for room sale if selected
                const matchesRoomSale = sortRoomSale == "" || room.ID_ROOM_SALE == sortRoomSale;
                // Apply filter for status rate if selected
                const matchesStatusRate = statusRateFilter == "" || room.STATUS_ROOM_RATE == parseInt(statusRateFilter);
                return matchesRoomSale && matchesStatusRate;
              })
              .map((room,index) => (

                <div key={index} className="mb-6">
                  <div className="flex justify-between items-center mb-4">
                  <h3 className={`text-base font-semibold ${room.STATUS_ROOM_RATE === 0 ? 'text-gray-300' : 'text-blue-600'}`}>
                    {room.ROOM_NAME} {room.STATUS_ROOM_RATE == 0 ? '(Non Active)' : ''}
                  </h3>
                    {/* Mini Buttons */}
                    <div className="flex space-x-2">
                            {/* Settings Button */}
                            <button
                              className="flex items-center justify-center w-8 h-8 bg-gray-200 hover:bg-gray-300 text-gray-600 rounded-full shadow-md"
                              title="Settings"
                              onClick={() => console.log("Settings clicked")}
                            >
                              <HiCog size={18} />
                            </button>

                            {/* Upload Excel Button */}
                            <button
                              className="flex items-center justify-center w-8 h-8 bg-gray-200 hover:bg-gray-300 text-gray-600 rounded-full shadow-md"
                              title="Upload Excel"
                              onClick={() => handleUploadModalToggle(room.ID_ROOM_SALE)}
                            >
                              <HiUpload size={18} />
                            </button>

                            {/* Add Rate by Range Date Button */}
                            <button
                              className="flex items-center justify-center w-8 h-8 bg-gray-200 hover:bg-gray-300 text-gray-600 rounded-full shadow-md"
                              title="Add Rate by Range Date"
                              onClick={() => handleAddRatebyDate(room)}
                            >
                              <HiCalendar size={18} />
                            </button>
                    </div>
                        
                  </div>
                  <div className="overflow-x-auto hide-scrollbar">
                    <table className="w-full bg-white border border-gray-300 shadow-md rounded-lg">
                      <thead>
                        <tr className="bg-gray-100 border-b border-gray-300">
                          {allDates.map((date, index) => (
                            <th
                              key={index}
                              className="px-2 py-2 text-center hover:bg-gray-500 hover:text-gray-50 text-[11px] font-medium text-gray-700 border-r border-gray-300"
                              onClick={()=>getDetailRate(date,room.ID_ROOM_SALE)}
                            >
                              {moment(date).format("ll")}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border-t border-gray-200">
                          {allDates.map((date, index) => {
                            const rateForDate = room.RATES?.find((rate) => rate.FROM_DATE === date);
                            return (
                              <td
                                key={index}
                                className={`px-4 py-2 text-xs text-center font-semibold border-b border-r border-gray-300 ${
                                  rateForDate && rateForDate.ALLOCATION > 0 && rateForDate.STATUS_RATE > 1
                                    ? "text-red-500"
                                    : "text-blue-500"
                                }`}
                              >
                                {rateForDate ? (
                                  new Intl.NumberFormat("id-ID", {
                                    style: "decimal",
                                  }).format(rateForDate.PRICE_ROOM / 1000) + "K"
                                ) : (
                                  <div className="text-gray-500"> <HiCog className="text-gray-500" onClick={()=>getDetailRate(date,room.ID_ROOM_SALE)}/></div>
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ))
            )}
          </section>
        </main>
      </div>

      {/* Upload Excel Modal */}
      {isUploadModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96 shadow-lg">
            <h2 className="text-lg font-semibold text-gray-700 mb-4">Upload Excel File</h2>
            <pre className="my-1" onClick={() => window.location.href = 'https://apiadminbooking.ashleyhotelgroup.co.id/uploads/Book1.xlsx'} style={{cursor: 'pointer'}}>
              (Download Template)
            </pre>

            {uploadProgress > 0 && (
              <div className="relative w-full bg-gray-200 rounded-full h-4 mt-4">
                <div
                  className="absolute top-0 left-0 h-4 bg-blue-500 rounded-full"
                  style={{ width: `${uploadProgress}%` }}
                ></div>
              </div>
            )}
            <input
              type="file"
              className="border border-gray-300 rounded-lg w-full p-2 mb-4"
              accept=".xlsx, .xls, .csv"
              onChange={(e) => setSelectedFile(e.target.files[0])}
            />
            <div className="flex justify-end space-x-2">
              <button className="bg-gray-300 hover:bg-gray-400 text-gray-700 rounded px-4 py-2" onClick={handleUploadModalToggle}>
                Cancel
              </button>
              <button onClick={handleFileUpload} className="bg-blue-500 hover:bg-blue-600 text-white rounded px-4 py-2">
                Upload
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Detail Rate */}
      {isRateModalOpen && rateDetail && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96 shadow-lg">
            <h2 className="text-lg font-semibold text-gray-700">
              {rateDetail.ROOM_NAME} - {rateDetail.NAME_RATE}
            </h2>
            <p className="text-sm text-gray-600 mb-6">
              {moment(rateDetail.FROM_DATE).format("ll")} 
              &nbsp;-&nbsp;
              {moment(rateDetail.TO_DATE).format("ll")}
            </p>

            {/* Form Fields */}
            <div className="space-y-4 mb-6">
              {/* Price Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Price</label>

                <NumericFormat
                  value={rateDetail.PRICE_ROOM }
                  onValueChange={handlePriceChangeDetail} // Handles the raw number
                  className="border border-gray-300 h-12 rounded-lg w-full py-6 pl-2 font-bold text-2xl text-gray-500"
                  thousandSeparator={true} // Adds commas
                  prefix="Rp." // Optional: if you want a currency symbol
                  allowNegative={false} // Prevents negative values
                />
              </div>

               {/* Price Field */}
               <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Disc %</label>
                <input
                  type="number"
                  className="border border-gray-300 rounded-lg w-full p-2 text-sm"
                  placeholder="Enter price"
                  value={rateDetail.DISC_ROOM || "0"}
                  onChange={(e) => setRateDetail((prev) => ({ ...prev, DISC_ROOM: e.target.value }))}
                />
              </div>

              {/* Allocation Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Allocation</label>
                <input
                  type="number"
                  className="border border-gray-300 rounded-lg w-full p-2 text-sm"
                  placeholder="Enter allocation"
                  defaultValue={0}
                  value={rateDetail.ALLOCATION}
                  onChange={(e) => setRateDetail((prev) => ({ ...prev, ALLOCATION: e.target.value }))}
                />
              </div>

              {/* Toggle Status Field */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Status Rate</label>
                <div className="flex items-center">
                  <span className="mr-2 text-sm">{rateDetail.STATUS_RATE === 1 ? "Active" : "Closed"}</span>
                  <button
                    className={`w-10 h-6 rounded-full ${
                      rateDetail.STATUS_RATE === 1 ? "bg-green-500" : "bg-gray-300"
                    } relative`}
                    onClick={() =>
                      setRateDetail((prev) => ({
                        ...prev,
                        STATUS_RATE: prev.STATUS_RATE === 1 ? 2 : 1,
                      }))
                    }
                  >
                    <span
                      className={`w-4 h-4 bg-white rounded-full absolute top-1 transition-transform ${
                        rateDetail.STATUS_RATE === 1 ? "inset-5" : "inset-1"
                      }`}
                    ></span>
                  </button>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end space-x-2">
              <button
                className="bg-gray-300 hover:bg-gray-400 text-gray-700 rounded px-4 py-2"
                onClick={() => setIsRateModalOpen(false)}
              >
                Cancel
              </button>
              <button
                onClick={updateRateDetail}
                className="bg-blue-500 hover:bg-blue-600 text-white rounded px-4 py-2"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {isRateAddbyDateModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-auto max-w-5xl shadow-lg relative overflow-auto max-h-[calc(100vh-3rem)]">
            {/* Close Button with HiX Icon */}
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              onClick={() => setIsRateAddbyDateModalOpen(false)} // Close modal
            >
              <HiX className="h-6 w-6" /> {/* HiX icon used for close */}
            </button>

            <h2 className="text-xl font-semibold text-gray-700 mb-6">
              {roomSale.ROOM_NAME}
            </h2>

            {/* Date Range Field */}
            <div className="flex justify-center items-center">
              <DayPicker
                mode="range" // Enable range mode
                numberOfMonths={2}
                defaultMonth={today}
                selected={selectedRange}
                onSelect={setSelectedRange}
                disabled={[{ before: today }]}
                locale={id} // Set the locale to Indonesian
              />
            </div>

            <p className="text-sm font-smaller mt-8">
              {selectedRange.from && selectedRange.to
                ? `Selected Date  : ${moment(selectedRange.from).format('ll')} - ${moment(selectedRange.to).format('ll')}`
                : "Please select a Date"}
            </p>

            {/* Form Fields */}
            <div className="space-y-4 mt-4">
              {/* Price Field */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Price</label>
                <NumericFormat
                  value={price}
                  onValueChange={handlePriceChange} // Handles the raw number
                  className="border border-gray-300 h-12 rounded-lg w-full py-6 pl-2 font-bold text-2xl text-gray-500"
                  thousandSeparator={true} // Adds commas
                  prefix="Rp." // Optional: if you want a currency symbol
                  allowNegative={false} // Prevents negative values
                />
              </div>

              {/* Discount Field */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Disc (%)</label>
                <input
                  type="number"
                  className="border border-gray-300 rounded-lg w-full p-2 text-sm"
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                />
              </div>

              {/* Quota */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Quota</label>
                <input
                  type="number"
                  className="border border-gray-300 rounded-lg w-full p-2 text-sm"
                  value={quota}
                  onChange={(e) => setQuota(e.target.value)}
                />
              </div>

              {/* Status Rate (Toggle) */}
              <div className="mb-4 flex items-center">
                <label className="block text-xs font-medium text-gray-700 mb-1 mr-3">Status Rate : </label>
                <button
                  onClick={handleStatusToggle}
                  className={`px-4 py-2 text-xs rounded-full text-white ${status === 1 ? "bg-green-500" : "bg-red-500"}`}
                >
                  {status === 1 ? "Active" : "Non-Active"}
                </button>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end space-x-2 mt-4">
              <button
                className="bg-gray-300 hover:bg-gray-400 text-gray-700 rounded px-4 py-2"
                onClick={() => setIsRateAddbyDateModalOpen(false)} // Close modal on cancel
              >
                Cancel
              </button>
              {selectedRange.from && selectedRange.to && quota && price ? (
              <button
                onClick={handleAddRatebasedOnDate} // Your save logic
                className="bg-blue-500 hover:bg-blue-600 text-white rounded px-4 py-2"
              >
                Save
              </button>
            ) : null}
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default RateSetting;
